import { useEffect, useMemo, useState } from "react";
import { useLocalStorage } from "../../hooks/useLocalStoreg";
import "./NewPayment.css";

import {
  _colorText,
  _size,
  _sizeHeading,
  _sizeText,
  _style,
  _typeInput,
  _typeLabel,
} from "../../core/core";

import ArrowRightSvg from "../../assets/taiga-uikit/icons/arrow-right-1.svg?react";
import CandleSvg from "../../assets/taiga-uikit/icons/candle-2.svg?react";
import { Button } from "../../components/button/button";
import { Input } from "../../components/inputs/Input";
import { InputCounter } from "../../components/inputs/InputCounter";
import { Text } from "../../components/texts/text";
import Title from "../../components/texts/title";

import {
  CreateOrderRequest,
  Discont,
  IBlockPayment,
  JobTemplate,
  MEDIA_HM_PATH,
  ProductFront,
  UslugaFindByUrlResponse,
} from "@project/shared-types";
import { useFeatureFlagVariantKey } from "posthog-js/react";
import { useLoaderData } from "react-router";
import { v4 as uuidv4 } from "uuid";
import { CreateOrderAPI } from "../../api/payments/CreateOrderAPI";
import { Loader } from "../../components/Loader/Loader";
import { Label } from "../../components/texts/label";
import { useData } from "../../hooks/DataContext";
import { sendMetrics } from "../../hooks/analitics/sendMetrics";
import { DiscontsView } from "../DiscontsView/DiscontsView";
import { JobsPayment } from "./JobsPayment/JobsPayment";
interface INewPayment {
  block: IBlockPayment;
}

export const NewPayment = ({ block, ...props }: INewPayment) => {
  const { products } = useData();
  const data = useLoaderData<UslugaFindByUrlResponse>();

  const expVariant = useFeatureFlagVariantKey('setting-enable')
  const [defaultServiceId, setDefaultServiceId] = useState(
    data.usluga?.product_id
  );
  const currentService = useMemo(() => {
    return products.find((p) => p.id === data.usluga?.product_id);
  }, [products, defaultServiceId]);
  useEffect(() => {
    if (products) {
      setDefaultServiceId(data.usluga?.product_id);
    }
  }, [products, data]);
  useEffect(() => {
    if (currentService) {
      setCount(currentService.default_count);
    }
  }, [currentService]);
  const [url, setUrl] = useLocalStorage(`fast_url_${defaultServiceId}`, "");
  const [count, setCount] = useState(currentService?.default_count ?? 1);
  const [sumCount, setSumCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingOrder, setIsLoadingOrder] = useState(false);
  const [email, setEmail] = useLocalStorage("email", "");
  const [isUpdateDisconts, setIsUpdateDisconts] = useState(true);
  const [description, setDescription] = useLocalStorage(
    `fast_description_${defaultServiceId}`,
    ""
  );
  const [errorEmail, setErrorEmail] = useState("");
  const [errorUrl, setErrorUrl] = useState("");
  const [isUseForm, setIsUseForm] = useState(false);
  const [global_id, setGlobal_id] = useState<string | undefined>(
    typeof window !== "undefined"
      ? localStorage.getItem("global_id") || uuidv4()
      : undefined
  );
  const [discont, setDiscont] = useState<Discont | undefined>(undefined);
  const [jobs, setJobs] = useState<JobTemplate[]>([]);
  const [isActiveJobs, setIsActiveJobs] = useState(false);
  /// DISCONT
  const getPrice = () => {
    if (discont)
      if (discont.start_sum <= sumCount * count)
        return Math.round((sumCount * count * (100 - discont.percent)) / 100);
    return Math.round(sumCount * count);
  };
  const onEmailBlur = () => {
    setIsUpdateDisconts(true);
  };

  const getDiscontSum = () => {
    if (discont) {
      if (discont.start_sum <= sumCount * count)
        return Math.round((sumCount * count * discont.percent) / 100);
      return -1;
    }
    return 0;
  };

  const getDescDiscont = () => {
    if (discont) {
      const desc = getDiscontSum();
      if (desc > 0)
        return (
          <div className="new-payment-info-row">
            <Text size={_sizeText.hmp2} color={_colorText.black}>
              Скидка{" "}
            </Text>
            <Text size={_sizeText.hmp2} color={_colorText.black}>
              {getDiscontSum()} ₽{" "}
            </Text>
          </div>
        );
      else if (desc == -1)
        return (
          <div className="new-payment-info-row">
            <Text size={_sizeText.hmp2} color={_colorText.negative}>
              Скидка не активна, нехватает
            </Text>
            <Text size={_sizeText.hmp2} color={_colorText.negative}>
              {Math.round(discont.start_sum - sumCount * count)} ₽{" "}
            </Text>
          </div>
        );
    }
    return <></>;
  };
  const getCountDiscont = () => {
    if (!currentService) return <></>;
    if (count == 1) {
      const step =
        (currentService.new_max_price - currentService.new_min_price) /
        currentService.new_coeff_price; // Разница в значении sum между каждым значением count
      const sum = Math.round(
        currentService.new_max_price * currentService.default_count -
        (currentService.new_max_price -
          (currentService.default_count - 1) * step) *
        currentService.default_count
      );
      return (
        <div
          onClick={() => {
            setCount(currentService.default_count);
          }}
          className="new-payment-help-body"
        >
          <Text size={_sizeText.hmpmed} color={_colorText.black}>
            Скидка за {currentService.default_count} штук
          </Text>
          <Text size={_sizeText.hmpmed} color={_colorText.black}>
            {sum} ₽
          </Text>
        </div>
      );
    } else {
      const sum = currentService.new_max_price * count - sumCount * count;

      return (
        <div className="new-payment-help-body">
          <Text size={_sizeText.hmpmed} color={_colorText.black}>
            Скидка за количество
          </Text>
          <Text size={_sizeText.hmpmed} color={_colorText.black}>
            {sum} ₽
          </Text>
        </div>
      );
    }
  };
  const onCountBlur = () => {
    console.log(count);

    sendMetrics("reachGoal", "cheackPrice");
  };
  const isText = () => {
    if (currentService)
      for (const step of currentService.place.steps_work) {
        for (const item of step.inputs) {
          if (item.type == "text") return true;
        }
      }
    return false;
  };
  const isService = () => {
    return isText();
  };
  // DISCONT END
  //validations
  const validateEmail = () => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (email.length > 0) {
      if (email.indexOf("@") == -1) {
        return "Адрес электронной почты не содержит @";
      } else if (!emailPattern.test(email)) {
        return "Неверный формат адреса электронной почты";
      }
    }
    return "";
  };
  const createOrder = async () => {
    sendMetrics("reachGoal", "clickPay");
    if (email.length == 0) {
      setErrorEmail("Укажите почту");

      return;
    } else if (url.length == 0) {
      setErrorUrl("Укажите ссылку");

      return;
    }
    try {
      setIsLoadingOrder(true);
      let discontTrue = undefined;
      if (discont) {
        const desc = getDiscontSum();
        if (desc !== -1) discontTrue = discont;
      }
      if (!currentService) return;
      const dataOrder = {
        place_id: currentService?.place_id,
        email: email,
        global_id: global_id,
        product_id: currentService?.id,
        description: description,
        count: count,
        url: url,
        discont: discontTrue,
        jobs: jobs,
      } as CreateOrderRequest;
      const response = await CreateOrderAPI(dataOrder); // Замените '/api/service-previews' на ваше API-оконечное точка для получения карточек услуг
      if (Object.values(response.errors).length > 0) {
        if (response.errors["email"]) setErrorEmail(response.errors["email"]);
        if (response.errors["url"]) setErrorEmail(response.errors["url"]);
      } else {
        document.location.href = response.url;
      }
    } catch (error) {
      sendMetrics("reachGoal", "error_createOrder");
      console.error("Ошибка при получении карточек услуг:", error);
    }
  };

  const getPlaceholder = () => {
    return `Укажите ссылку на ${currentService?.new_place_url}`;
  };
  useEffect(() => {
    // Код, который выполнится при изменении count
    console.log("Состояние count изменилось:", count);
    if (currentService) updateCurrentSum(currentService);
  }, [count, discont, currentService]);
  const updateCurrentSum = (current: ProductFront) => {
    if (!currentService) return;
    const step =
      (current.new_max_price - current.new_min_price) /
      currentService.new_coeff_price; // Разница в значении sum между каждым значением count
    const newSum = Math.round(current.new_max_price - (count - 1) * step); // Расчет значения sum в зависимости от count

    if (current.new_min_price <= newSum) setSumCount(Math.round(newSum));
    else setSumCount(Math.round(current.new_min_price));
  };
  return (
    <div id={block.id} className={"block-payment"}>
      <Title>{block.title}</Title>
      <div className="new-payment">
        {isLoading && currentService ? (
          <>
            <div
              onClick={() => {
                if (!isUseForm) {
                  setIsUseForm(true);
                }
              }}
              className="new-payment-main"
            >
              <div className="new-payment-body">
                <div className="new-payment-header">
                  <img
                    height="24"
                    width="24"
                    src={`${MEDIA_HM_PATH}${currentService.icon}`}
                    alt={`иконка svg ${currentService.new_place_name}`}
                  ></img>
                  <Title type={_sizeHeading.h3}>
                    {currentService.new_name} на {currentService.new_place_name}
                  </Title>
                </div>
                <div className="new-payment-form">
                  <Input
                    type={_typeInput.text}

                    onFocus={() => {
                      sendMetrics('reachGoal', 'focus_url');
                    }}
                    value={url}
                    setValue={setUrl}
                    error={errorUrl}
                    size={_size.M}
                    placeholder={getPlaceholder()}
                    labelOutside={"Ссылка"}
                  ></Input>
                  <div className="new-payment-form-group">
                    <InputCounter
                      onBlurHandel={onCountBlur}
                      value={count}
                      setValue={setCount}
                      size={_size.M}
                      labelOutside={"Количество"}
                      descriptionComp={
                        <div className={"new-payment-group-line"}>
                          <Label
                            size={_size.XS}
                            type={_typeLabel.input}
                          >{`${sumCount} ₽/шт`}</Label>
                          {count != 1 && (
                            <div>
                              <svg
                                className={"new-payment-line"}
                                width="60"
                                height="14"
                                viewBox="0 0 60 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M1 13L59 1"
                                  stroke="#FF5C00"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                />
                              </svg>
                              <Label
                                size={_size.XS}
                                type={_typeLabel.input}
                              >{`${currentService.new_max_price} ₽/шт`}</Label>
                            </div>
                          )}
                        </div>
                      }
                    ></InputCounter>
                    <div className="new-payment-help">{getCountDiscont()}</div>
                  </div>
                  <Input
                    type={_typeInput.email}
                    value={email}
                    onFocus={() => {
                      sendMetrics('reachGoal', 'focus_email');
                    }}
                    validation={validateEmail}
                    onBlurHandel={onEmailBlur}
                    setValue={setEmail}
                    error={errorEmail}
                    placeholder={"Укажите почту для связи с вами"}
                    labelOutside={"Почта"}
                    size={_size.M}
                  ></Input>
                  <Input
                    type={_typeInput.text}

                    value={description}
                    setValue={setDescription}
                    size={_size.M}
                    label={"Ваши пожелания к заказу"}
                    labelOutside={"Коментарий к заказу"}
                  ></Input>
                  {isService() && expVariant === 'control' && (
                    <>
                      <div className="block-setting">
                        <Button
                          width={"100%"}
                          onClick={() => setIsActiveJobs(!isActiveJobs)}
                          isMobileWidth={true}
                          size={_size.M}
                          style={_style.outline}
                          icon_left={<CandleSvg></CandleSvg>}
                          icon_right={<ArrowRightSvg />}
                        >
                          Настроить отзывы (текст, фото, дата)
                        </Button>
                      </div>

                      <div className="block-setting-mob">
                        <Button
                          width={"100%"}
                          onClick={() => setIsActiveJobs(!isActiveJobs)}
                          isMobileWidth={true}
                          size={_size.M}
                          style={_style.outline}
                          icon_left={<CandleSvg></CandleSvg>}
                          icon_right={<ArrowRightSvg />}
                        >
                          Настроить (текст, фото, дата)
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="new-payment-footer">
                <DiscontsView
                  discont={discont}
                  setDiscont={setDiscont}
                  isUpdateDisconts={isUpdateDisconts}
                  setIsUpdateDisconts={setIsUpdateDisconts}
                  email={email}
                  global_id={global_id}
                ></DiscontsView>
                <div className="new-payment-info">
                  <div className="new-payment-info-row">
                    <Text size={_sizeText.hmp2} color={_colorText.black}>
                      Стоимость за 1 шт
                    </Text>
                    <Text size={_sizeText.hmp2} color={_colorText.black}>
                      {sumCount} ₽
                    </Text>
                  </div>
                  {getDescDiscont()}
                  <div className="new-payment-info-row">
                    <Text size={_sizeText.hmp2} color={_colorText.black}>
                      Итого к оплате ({count} шт)
                    </Text>
                    <Text size={_sizeText.hmp2} color={_colorText.black}>
                      {getPrice()} ₽
                    </Text>
                  </div>
                </div>
                {errorEmail ||
                  (errorUrl && (
                    <div className="new-payment-error">
                      <Text size={_sizeText.hmp2} color={_colorText.negative}>
                        {errorEmail || errorUrl}
                      </Text>
                    </div>
                  ))}
                <Button
                  onClick={createOrder}
                  width={"100%"}
                  isMobileWidth={true}
                  size={_size.M}
                >
                  {isLoadingOrder ? (
                    <Loader isLoading></Loader>
                  ) : (
                    "Оплатить и запустить"
                  )}
                </Button>
              </div>
            </div>
            <JobsPayment
              block={block}
              count={count}
              setCount={setCount}
              jobs={jobs}
              setJobs={setJobs}
              setIsJobsActivePage={setIsActiveJobs}
              IsJobsActivePage={isActiveJobs}
              onCreateOrder={createOrder}
            ></JobsPayment>
          </>
        ) : (
          <Loader isLoading></Loader>
        )}
      </div>
    </div>
  );
};
